<section class="price-page">
  <div class="plan-info" *ngIf="emailId !== undefined && emailId !== '' && emailId !== null" >
    <svg width="39" height="29" viewBox="0 0 39 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M37.7458 22.3555C38.2182 22.0695 38.3694 21.4547 38.0835 20.9822C37.7975 20.5097 37.1826 20.3585 36.7102 20.6445L37.7458 22.3555ZM10.728 0L0.093259 4.49849L9.30641 11.4592L10.728 0ZM36.7102 20.6445C32.4643 23.2144 27.4332 25.1017 22.5147 26.1122C17.5857 27.1248 12.8453 27.2414 9.16412 26.3428C5.48197 25.4439 3.04407 23.5909 2.27166 20.7841C1.47929 17.9048 2.32356 13.6549 6.14476 7.72056L4.46322 6.63778C0.537787 12.734 -0.67711 17.6066 0.34334 21.3148C1.38374 25.0954 4.63064 27.2948 8.6898 28.2857C12.7499 29.2769 17.8074 29.121 22.9172 28.0713C28.0374 27.0194 33.2863 25.0547 37.7458 22.3555L36.7102 20.6445Z"
        fill="#F00E0E" />
    </svg>
    This is your current plan
  </div>
  <div class="title-wrap tk-flex">
    <h1>
      Our Plans are made<br /><span>
        In<span class="special">Kredibly Intelligently...</span></span>
    </h1>
    <span class="plan">**Billed Yearly</span>
  </div>


  <div class="pricing-plans-wrap">
    <div class="row">
      <div class="col-sm col-md-6">
        <div class="card-price-plan card-bg-white">
          <div class="card-top d-flex">
            <span class="plan-type">Basic</span>
            <span class="plan-price">Free</span>
          </div>
          <div class="summary">
            Individual users will have limited access to the content and data.Overview of the company, funding
            highlights, general financial news etc. will be available to the user.
          </div>
          <div class="btn-wrap d-flex">
            <button class="btn btn-darkblue-bg" *ngIf="!this.onSession" (click)="registered()">
              Register for free
            </button>
            <button class="btn btn-grey-bg" *ngIf="this.onSession" (click)="contactSales()" [disabled]="true">
              Contact Sales
            </button>
          </div>
        </div>
      </div>
      <div class="col-sm col-md-6">
        <div class="card-price-plan card-bg-white">
          <div class="card-top d-flex">
            <span class="plan-type">Advance</span>
            <span class="plan-price">
              {{ packages?.plan_advance?.price | currency:'INR':'symbol':'1.0-0' }}
            </span>
            <!-- <span class="plan-bill-info">Billed Annually</span> -->
          </div>
          <div class="summary">
            Up to 2 users will have limited access to the content and data.Users will also have access to investments,
            acquisitions, revenue breakdowns etc.
          </div>
          <div class="btn-wrap">
            <button class="btn btn-grey-bg" *ngIf="packages?.plan_advance?.isSubscribed || packages?.plan_premium?.isSubscribed" [disabled]="true">
              Advance Subscriber
            </button>

            <button class="btn btn-dark-blue-bg" *ngIf="
                !packages?.plan_advance?.isSubscribed &&
                !packages?.plan_premium?.isSubscribed &&
                onSession
              " (click)="purchasedPlan('plan_advance')">
              Purchase Now
            </button>

            <button class="btn btn-darkblue-bg" [disabled]="disableButtons" *ngIf="!onSession" (click)="registered()">
              Login & Purchase Now
            </button>

            <button class="btn btn-grey-bg" (click)="contactSales()">
              Contact Sales
            </button>
          </div>
        </div>
      </div>
      <div class="col-sm col-md-6">
        <div class="card-price-plan card-bg-white">
          <div class="card-top d-flex">
            <div class="left-sec">
              <span class="plan-type">Premium</span>
              <span class="popular-text">Most Popular
                <svg width="160" height="26" viewBox="0 0 160 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 0H160L150 26H0L10 0Z" fill="#7939CC" />
                </svg>
              </span>
            </div>
            <span class="plan-price">
              {{ packages?.plan_premium?.price | currency:'INR':'symbol':'1.0-0' }}
            </span>
            <!-- <span class="plan-bill-info">Billed Annually</span> -->
          </div>
          <div class="summary">
            Up to 3 users will have unlimited access to the content and data on the platform. Additionally, the users
            will have access to data regarding shareholding structure, financing ratios, company documents etc.
          </div>
          <div class="btn-wrap">
            <button class="btn btn-outline-light btn-grey-bg" *ngIf="packages?.plan_premium?.isSubscribed"
              [disabled]="true">
              Premium Subscriber
            </button>

            <button class="btn btn-outline-light btn-dark-blue-bg" *ngIf="
                !packages?.plan_advance?.isSubscribed &&
                !packages?.plan_premium?.isSubscribed &&
                onSession
              " (click)="purchasedPlan('plan_premium')">
              Purchase Now
            </button>

            <button class="btn btn-outline-light btn-darkblue-bg" [disabled]="disableButtons"
              *ngIf="packages?.plan_advance?.isSubscribed" (click)="purchasedPlan('plan_premium')">
              Upgrade Now
            </button>

            <button class="btn btn-outline-light btn-darkblue-bg" [disabled]="disableButtons" *ngIf="!onSession"
              (click)="registered()">
              Login & Purchase Now
            </button>

            <button class="btn btn-grey-bg" (click)="contactSales()">
              Contact Sales
            </button>
          </div>
        </div>
      </div>
      <div class="col-sm col-md-6">
        <div class="card-price-plan card-bg-white">
          <div class="card-top">
            <span class="plan-type">Enterprise</span>
            <p class="top-info">Tailor-Made Financial Intelligence for Your Growth</p>
          </div>
          <div class="summary">
            Ready to unlock the full potential of fnancial data across your entire organization? Our Enterprise Plan
            delivers custom-crafted solutions that
            go beyond of-the-shelf reports, empowering you to make critical business decisions with confdence.
          </div>
          <div class="btn-wrap">
            <button class="btn btn-grey-bg" (click)="contactSales()">
              Contact Sales
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="noteInfo">
    <h6>Note:</h6>
    <div class="discription">
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
    </div>
  </div> -->

  <div class="pricing-compare-wrap">
    <h2 class="sec-title">Compare Plans</h2>
    <table class="table table-nobordered desktop-table">
      <thead>
        <tr>
          <th>Offerings</th>
          <th class="text-left">Free</th>
          <th class="text-left">Advance</th>
          <th class="text-left">Premium</th>
          <th class="text-left">Enterprise</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <ul class="list-styled">
              <li>Company Overview</li>
              <li>Funding Highlights</li>
              <li>Valuation</li>
              <li>Funding Rounds Per Year</li>
              <li>Investment Company Has Done</li>
              <li>Acquisition Company Has Done</li>
              <li>Company Financials & Metrics (Highlights)</li>
              <li>Financial Comparison</li>
              <li>Revenue Breakdown</li>
              <li>Expense Breakdown</li>
              <li>Shareholding Structure</li>
              <li>Financial Ratios</li>
              <!-- <li>Traction Highlights</li>
              <li>Analytics & Tracking</li> -->
              <!-- <li>Company Comparison</li> -->
              <li>Core Team</li>
              <li>Board Members</li>
              <!-- <li>Competitors</li> -->
              <li>General News</li>
              <li>Financial News</li>
              <li>Funding News</li>
              <!-- <li>All Company Documents</li> -->
              <li>Company Documents</li>
            </ul>
          </td>
          <td class="text-left">
            <ul class="list-unstyled mb-0">
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="non-highlight">
                <i class="fa fa-times"></i>
              </li>
              <li class="non-highlight">
                <i class="fa fa-times"></i>
              </li>
              <li class="non-highlight">
                <i class="fa fa-times"></i>
              </li>
              <li class="non-highlight">
                <i class="fa fa-times"></i>
              </li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="non-highlight">
                <i class="fa fa-times"></i>
              </li>
              <li class="non-highlight">
                <i class="fa fa-times"></i>
              </li>
              <li class="non-highlight">
                <i class="fa fa-times"></i>
              </li>
              <li class="non-highlight">
                <i class="fa fa-times"></i>
              </li>
              <li class="non-highlight">
                <i class="fa fa-times"></i>
              </li>
              <li class="highlight">
                <i class="fas fa-check"></i>
              </li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="non-highlight">
                <i class="fa fa-times"></i>
              </li>
            </ul>
          </td>
          <td class="text-left">
            <ul class="list-unstyled mb-0">
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="non-highlight">
                <i class="fa fa-times"></i>
              </li>
              <li class="non-highlight">
                <i class="fa fa-times"></i>
              </li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="non-highlight">
                <i class="fa fa-times"></i>
              </li>
            </ul>
          </td>
          <td class="text-left premium">
            <ul class="list-unstyled mb-0">
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
            </ul>
          </td>
          <td class="text-left">
            <ul class="list-unstyled mb-0">
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
              <li class="highlight"><i class="fas fa-check"></i></li>
            </ul>
          </td>
        </tr>

      </tbody>
    </table>
    <div class="btn-wrap d-flex">
      <button class="btn btn-darkblue-bg" *ngIf="!this.onSession" (click)="registered()">Register</button>
      <button class="btn btn-dark-blue-bg" *ngIf="
      !packages?.plan_advance?.isSubscribed &&
      !packages?.plan_premium?.isSubscribed &&
      onSession" (click)="registered()">Purchase</button>
      <button class="btn btn-dark-blue-bg" *ngIf="
       !packages?.plan_advance?.isSubscribed &&
        !packages?.plan_premium?.isSubscribed &&
       onSession" (click)="registered()">Purchase</button>
      <button class="btn btn-dark-blue-bg" *ngIf="!this.onSession" (click)="registered()">Purchase</button>
      <button class="btn btn-dark-blue-bg" *ngIf="!this.onSession" (click)="registered()">Purchase</button>
      <button class="btn btn-grey-bg">Contact Sales</button>
    </div>
    <!--mobile layout-->
    <div class="price-list-view mobile-list">
      <p class="title">Free</p>
      <ul class="price-list list-unstyled mb-0">
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Company Overview
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Funding Highlights
        </li>
        <li class="list-item d-flex non-highlight">
          <i class="fa fa-times"></i>Funding Rounds Per Year
        </li>
        <li class="list-item d-flex non-highlight">
          <i class="fa fa-times"></i>Investment Company Has Done
        </li>
        <li class="list-item d-flex non-highlight">
          <i class="fa fa-times"></i>Acquisition Company Has Done
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Company Financials & Metrics
          (Highlights)
        </li>
        <li class="list-item d-flex non-highlight">
          <i class="fa fa-times"></i>Financial Comparison
        </li>
        <li class="list-item d-flex non-highlight">
          <i class="fa fa-times"></i>Revenue Breakdown
        </li>
        <li class="list-item d-flex non-highlight">
          <i class="fa fa-times"></i>Expense Breakdown
        </li>
        <li class="list-item d-flex non-highlight">
          <i class="fa fa-times"></i>Shareholding Structure
        </li>
        <li class="list-item d-flex non-highlight">
          <i class="fa fa-times"></i>Financial Ratios
        </li>
        <!-- <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Traction Highlights
        </li> -->
        <li class="list-item d-flex non-highlight">
          <i class="fa fa-times"></i>Analytics & Tracking
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Core Team
        </li>
        <li class="list-item d-flex non-highlight">
          <i class="fa fa-times"></i>Board Member
        </li>
        <li class="list-item d-flex non-highlight">
          <i class="fa fa-times"></i>Competitors
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>General News
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Financial News
        </li>
        <li class="list-item d-flex non-highlight">
          <i class="fa fa-times"></i>Funding News
        </li>
        <!-- <li class="list-item d-flex non-highlight">
          <i class="fas fa-check"></i>All Company Documents
        </li> -->
        <!-- <li class="list-item d-flex non-highlight">
          <i class="fas fa-check"></i>Specific Company Documents
        </li> -->
      </ul>
      <p class="title">Advance</p>
      <ul class="price-list list-unstyled mb-0">
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Company Overview
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Funding Highlights
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Funding Rounds Per Year
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Investment Company Has Done
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Acquisition Company Has Done
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Company Financials & Metrics
          (Highlights)
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Financial Comparison
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Revenue Breakdown
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Expense Breakdown
        </li>
        <li class="list-item d-flex non-highlight">
          <i class="fa fa-times"></i>Shareholding Structure
        </li>
        <li class="list-item d-flex non-highlight">
          <i class="fa fa-times"></i>Financial Ratios
        </li>
        <!-- <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Traction Highlights
        </li> -->
        <li class="list-item d-flex non-highlight">
          <i class="fa fa-times"></i>Analytics & Tracking
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Core Team
        </li>
        <li class="list-item d-flex non-highlight">
          <i class="fa fa-times"></i>Board Member
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Competitors
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>General News
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Financial News
        </li>
        <li class="list-item d-flex non-highlight">
          <i class="fa fa-times"></i>Funding News
        </li>
        <!-- <li class="list-item d-flex non-highlight">
          <i class="fas fa-check"></i>All Company Documents
        </li> -->
        <!-- <li class="list-item d-flex non-highlight">
          <i class="fas fa-check"></i>Specific Company Documents
        </li> -->
      </ul>
      <p class="title">Premium</p>
      <ul class="price-list list-unstyled mb-0">
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Company Overview
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Funding Highlights
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Funding Rounds Per Year
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Investment Company Has Done
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Acquisition Company Has Done
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Company Financials & Metrics
          (Highlights)
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Financial Comparison
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Revenue Breakdown
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Expense Breakdown
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Shareholding Structure
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Financial Ratios
        </li>
        <!-- <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Traction Highlights
        </li> -->
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Analytics & Tracking
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Core Team
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Board Member
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Competitors
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>General News
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Financial News
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Funding News
        </li>
        <!-- <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>All Company Documents
        </li> -->
        <!-- <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Specific Company Documents
        </li> -->
      </ul>
      <p class="title">Enterprise</p>
      <ul class="price-list list-unstyled mb-0">
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Company Overview
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Funding Highlights
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Funding Rounds Per Year
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Investment Company Has Done
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Acquisition Company Has Done
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Company Financials & Metrics
          (Highlights)
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Financial Comparison
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Revenue Breakdown
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Expense Breakdown
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Shareholding Structure
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Financial Ratios
        </li>
        <!-- <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Traction Highlights
        </li> -->
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Analytics & Tracking
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Core Team
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Board Member
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Competitors
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>General News
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Financial News
        </li>
        <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Funding News
        </li>
        <!-- <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>All Company Documents
        </li> -->
        <!-- <li class="list-item d-flex highlight">
          <i class="fas fa-check"></i>Specific Company Documents
        </li> -->
      </ul>
    </div>
  </div>

  <!-- ` -->

  <div class="scbscribe-wrap">
    <app-subscribe-form-component></app-subscribe-form-component>
  </div>
</section>